<template>
    <div style="padding:1rem 2rem 1rem 2rem">
        <div v-if="!$route.params.id">
        <h4>Новости</h4>
        <b-card v-if="isOrgAdmin"
            title="Добавить"
            style="text-align:left"
        >
            <b-card-text>
                Чтобы добавить новость нажмите соответствующую кнопку ...
            </b-card-text>

            <a @click="open_addNews = true" class="card-link">Добавить новость</a>
        </b-card>
        <b-card
            v-for="item in news" :key="item.id"
            :title="item.title"
            style="text-align:left;"
        >
            <b-card-text>
                {{item.description}}
            </b-card-text>
            <router-link :to="{ name: 'current-news', params: {id: item.id}}" class="card-link">Подробнее</router-link>
            <hr/>
            <span style="font-style:italic;font-size:12px; color:gray">Обновлено: {{item.createDate | date}}</span>
            <span v-if="isOrgAdmin" @click="deleteNews(item.id)" class="material-icons" style="position:absolute; top:10px; right:10px; cursor:pointer">close</span>
        </b-card>
</div>
        <Dialog v-if="open_addNews">
            <h4 slot="header">Добавить новость</h4>
             <div slot="body">
                 <div class="row">
                     <span>Название:</span>
                     <b-form-input type="text"  v-model="formNews.title"></b-form-input>
                    <span>Описание:</span>
                     <b-form-input type="text" v-model="formNews.description"></b-form-input>
                     <span>Новость:</span>
                     <b-form-textarea type="text" multiline v-model="formNews.text"></b-form-textarea>
                 </div>
             </div>
             <div slot="footer">
                    <b-button variant="info" @click="add_news()">Сохранить</b-button>
                    <b-button variant="danger" @click="closeNews()">Отменить</b-button>
            </div>
        </Dialog>
        <router-view />
    </div>
</template>

<script>
import Dialog from '@app/views/custom-components/modals/edit-modal';
import { organizationApi } from '@app/services';

export default {
    components: {
        Dialog
    },
    data() {
        return {
            open_addNews: false,
            formNews: {
                id: null,
                title: null,
                createDate: null,
                description: null,
                text: null,
                href: null,
            }
        };
    },
    computed: {
        news() {
            return this.$store.state.clinic.organization.form.front.news;
        },
        isOrgAdmin() {
            const role = this.$store.state.clinic.roles.filter(obj => obj === 'orgadmin')[0];
            return role ? true : false;
        },
    },
    filters: {
        date(str) {
            if (str) {
            const date = new Date(str);
            const options = { year: 'numeric', month: 'long', day: 'numeric' };
          return date.toLocaleDateString('ru-RU', options);
        }
        }
    },
    methods: {
        closeNews() {
            this.formNews.id = null;
            this.formNews.title = null;
            this.formNews.createDate = null;
            this.formNews.description = null;
            this.formNews.text = null;
            this.formNews.href = null;
            this.open_addNews = false;
        },
        add_news() {
            const front = this.$store.state.clinic.organization.form.front;
            if (!front.news) {
                front.news = [];
            }
                this.formNews.id = front.news.length + 1;
                this.formNews.createDate = new Date();
                this.formNews.href = `/news/${this.formNews.id}`;
            front.news.push(this.formNews);
            organizationApi.update({front: front}).then(res => {
                this.closeNews();
            }).catch(error => {
                console.log(error);
                front.news = front.news.filter(obj => obj.id !== this.formNews.id);
            });

        },
        deleteNews(id) {
            const front = this.$store.state.clinic.organization.form.front;
            front.news = front.news.filter(obj => obj.id !== id);
            organizationApi.update({front: front});
        }
    }
    
};
</script>

<style lang="scss" scoped>
::v-deep .card-body {
    text-align: left;
}
</style>